import React, {useState,useEffect} from 'react'
import { useHistory } from "react-router-dom"
import {Table,Button} from "react-bootstrap"
import "./enteral.css";
import Header from "./Header"
import { Icon, InlineIcon } from '@iconify/react';
import calculatorIcon from '@iconify-icons/entypo/calculator';
import homeIcon from '@iconify-icons/fa-solid/home';
import { round } from 'mathjs' 
import {Grid} from "@material-ui/core"
import GreenE from "./GreenE"
import OrangeE from "./OrangeE"
import RedE from "./RedE"
import GreenP from "./GreenP"
import OrangeP from "./OrangeP"
import RedP from "./RedP"

function CalcFeedRate() {
    let history = useHistory();

    
    var feedtype = localStorage.getItem("Type of feed")
    var hmf = localStorage.getItem("HMF")

    var wheyprotein = localStorage.getItem("whey protein")

    const actionPlan = () => {
        history.push("/")
        localStorage.clear()
    }

    const calculateAgain = () => {
        localStorage.clear()
        history.push("/enteral")
    }

    var weight = localStorage.getItem("current weight")
    //requirements
      if(weight<1){
       var energyR = 106
       localStorage.setItem("energyR" , energyR)
       var proteinR = 4.0
       localStorage.setItem("proteinR" , proteinR)
      }
      else if(weight<1.5){
       var energyR = 115
       localStorage.setItem("energyR" , energyR)
       var proteinR = 3.9
       localStorage.setItem("proteinR" , proteinR)
      }
      else if(weight<2.2){
       var energyR = 123
       localStorage.setItem("energyR" , energyR)
        var proteinR = 3.7
        localStorage.setItem("proteinR" , proteinR)
      }
      else if(weight < 3){
       var energyR = 130
       localStorage.setItem("energyR" , energyR)
       var proteinR = 3.4
       localStorage.setItem("proteinR" , proteinR)
      }
     


     var feedE = localStorage.getItem("feedE")
     var hmfE = localStorage.getItem("hmfE")
     var wheyproteinE = localStorage.getItem("wheyproteinE")
     var feedP = localStorage.getItem("feedP")
     var hmfP = localStorage.getItem("hmfP")
     var wheyproteinP = localStorage.getItem("wheyproteinP")
     


    // energy and protein intake for feeding rate
    // feed freq dont need to divide with weight => times weight @ feed frequency feed/hmfE and feed/hmfP
    var energy = round(((+feedE + +hmfE + +wheyproteinE) / weight))
    var energy1 =  round(energy * 4.184)
    var protein = round(((+feedP + +hmfP + +wheyproteinP)) / weight,2)



    //energyE %
    var energyRr = localStorage.getItem("energyR")
    var energyP = round((energy / energyRr) * 100)
    localStorage.setItem("percentage energy",energyP)

    //proteinE %
    var proteinRr = localStorage.getItem("proteinR")
    var proteinP = round((protein / proteinRr) * 100)
    localStorage.setItem("percentage protein",proteinP)
    
    

     //false ==> red => Energy
     const [isBackgroundRed, setisBackgroundRed] = useState(false);
     //false  ==> green => Protein
     const [isBackgroundGreen, setisBackgroundGreen] = useState(false);

      //energy
      const [green, setGreen] = useState(false);
      const [orange, setOrange] = useState(false);
      const [red, setRed] = useState(false);
      //protein
      const [greenP, setGreenP] = useState(false);
      const [orangeP, setOrangeP] = useState(false);
      const [redP, setRedP] = useState(false);
 
 

        //<50 RED
        //50-79 ORANGE (x)
        //80-100 GREEN

     const handleEnergy = () => {
       

        if ( energyP >= 50) { 
            setisBackgroundRed(true)
            setGreen(true)
            setOrange(false)
            setRed(false)
        }  
  
        else if ( energyP < 50 ) {
            setisBackgroundRed(false)
            setGreen(false)
            setOrange(false)
            setRed(true)
        }

        else {
            setGreen(false)
            setOrange(true)
            setRed(false)
        }
  
  
      }
  
      //for HC
  
      const handleProtein = () => {
  
          if (proteinP >= 80)  {
              setisBackgroundGreen(false);
              setGreenP(true)
              setOrangeP(false)
              setRedP(false)
          }
  
          else if (proteinP < 50 ) {
              setisBackgroundGreen(true)
              setGreenP(false)
              setOrangeP(false)
              setRedP(true)
          }

          else {
            setGreenP(false)
            setOrangeP(true)
            setRedP(false)
          }
  
      }
  
      useEffect(() => {
          handleEnergy()
          handleProtein()
          const interval = setInterval(() => {
            handleEnergy()
            handleProtein()
            }, 10000); //10 seconds
            return () => clearInterval(interval);
      }, [])




    return (
        <div className="row">
        <div className="col-md-12">
        <div className= "enteral__page">
        <Header/>
        <div className = "enteral__content">
            <form>
            <div className = "enteral__contentHeader">
                <p><strong>Feeding regime</strong></p>
            </div>
             <Table  className = "regime__table" striped   size="sm" responsive="sm" > 
                <thead>
                    <tr>
                        <td>
                            Weight (kg)
                        </td>
                        <td>
                            <strong>{weight}</strong>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Feed Type </td>
                        <td>
                                <strong>{feedtype ? feedtype : " "}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>HMF</td>
                        <td>
                                <strong>{hmf ? hmf : ""}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>Whey Protein (g) </td>
                        <td><strong>{wheyprotein} </strong></td>
                    </tr>
                </tbody>
            </Table>



            <div className = "enteral__contentHeader">
                <strong>Estimated Energy and Protein Intake <div className="goMid__and">AND</div> Percentage of Requirements Achieved</strong>
            </div>

            <Grid container spacing = {5}>
                <Grid item xs={3}>
                    {/*SPACE */}
                </Grid>
            <Grid item xs={3}>
                <div className = "">
                    kcals/kg/day
                </div>
            </Grid>
            <Grid item xs={3}>
                <div className = "kls__kg__day11">
                    kJ/kg/day
                </div>
                </Grid>
            </Grid>

        
            <Grid container spacing = {5}>
            <Grid item xs={3}>
                <strong>Energy</strong> 
            </Grid>
            <Grid item xs={3}>
                <button className="energy__buttonn">{energy}</button>
                
            </Grid>
            <Grid item xs={3}>
                <button className="energy__buttonn">{energy1}</button>
                </Grid>
            <Grid item xs={2}>
                <span onChange =  {handleEnergy} value = {energyP}> {green && <GreenE/>} </span>
                <span onChange =  {handleEnergy} value = {energyP}> {orange && <OrangeE/>} </span>
                <span onChange =  {handleEnergy} value = {energyP}> {red && <RedE/>} </span>
            </Grid>
            </Grid>
            

            


            <Grid container spacing = {5}>
                <Grid item xs={3}>
                    {/*SPACE */}
                </Grid>
            <Grid item xs={3}>
            <div className = "">
                g/kg/day
            </div>
            </Grid>
            <Grid item xs={3}>
                {/*SPACE*/}
                </Grid>
            </Grid>


            <Grid container spacing = {5}>
                <Grid item xs={3}>  
                <strong>Protein</strong>
                </Grid>
                <Grid item xs={3}> 
               <button className = "energy__buttonn">{protein}</button>
               </Grid>
               <Grid item xs={3}>
                    {/*SPACE */}
                </Grid>
                <Grid item xs={3}>
                    <div className = "push__totop">
                        <span onChange =  {handleProtein} value = {proteinP}> {greenP && <GreenP/>} </span>
                        <span onChange =  {handleProtein} value = {proteinP}> {orangeP && <OrangeP/>} </span>
                        <span onChange =  {handleProtein} value = {proteinP}> {redP && <RedP/>} </span>
                        </div>
                    </Grid>    
            </Grid>
            
           
            <button className = "goto__actionBtn" onClick = {actionPlan}>
            <Icon icon={homeIcon} />    Home
                </button> 
                <button className = "goto__homeBtn" onClick = {calculateAgain}>
                <Icon icon={calculatorIcon} />Calculate Another
                    </button>

            </form>
            </div>
             </div>
            </div>
        </div>
    )
}

export default CalcFeedRate
